import React, { Component } from 'react';
import { bindActionCreators, compose } from 'redux';
import { connect } from 'react-redux';
import { withRouter } from 'react-router';
import { push, goBack } from 'react-router-redux';
import {
  getCollectiblesEndorsementAddForm,
  getCollectiblesEndorsementAddCheckout,
  getCollectiblesEndorsementEditForm,
  getCollectiblesEndorsementEditCheckout,
  updateCollectiblesEndorsementCurrentResponse,
  saveCollectiblesEndorsementResponse,
  updateCollectiblesEndorsementAddress,
  surveyCollectiblesEndorsementBack,
  collectiblesEndorsementSurveyNext,
  deleteCollectiblesEndorsementResponse,
  resetCollectiblesEndorsementData,
  getPoliciesForVertical,
  getPolicyById,
  purchaseCollectiblesEndorsementAdd,
  purchaseCollectiblesEndorsementEdit,
  showMenu,
  hideMenu,
  hideToast,
} from '../../store/actions';
import withGlobals from '../../withGlobals';
import seo from 'shared/lib/seo';
import compact from 'lodash/compact';
import findKey from 'lodash/findKey';
import first from 'lodash/first';
import get from 'lodash/get';
import kebabCase from 'lodash/kebabCase';
import last from 'lodash/last';
import omit from 'lodash/omit';
import ModalSpinner from 'shared/lib/components/ModalSpinner';
import Toast from '../../components/Toast';
import TopNavBar from '../../components/TopNavBar';
import { getDisclaimer } from 'shared/lib/utils';
import COLLECTIBLES_CATEGORIES from 'shared/lib/constants/collectiblesCategories';

class CollectiblesEndorsementContainer extends Component {
  componentDidMount() {
    const { getPolicyById, params } = this.props;
    seo.setProps({
      title: 'Collectibles & Fine Arts | Sure',
      description:
        'Get Collectibles and Fine Arts insurance through Sure to protect your treasures.',
      url: 'https://www.sureapp.com/collectibles',
      fallback: true,
    });
    getPolicyById(params.policyId);
  }

  handleSubmitAddress = () => {
    this.props
      .getEndorsementForm({
        categoryCode: this.props.categoryCode,
        policyId: this.props.params.policyId,
      })
      .then(() => {
        this.props.navTo(
          `/account/policies/collectibles/${this.props.params.policyId}/${
            this.props.params.endorsementAction
          }/${this.props.categoryCode}/survey`
        );
      })
      .catch(this.props.onError);
  };

  handleCompleteSurvey = () => {
    this.props
      .getEndorsementCheckout({
        categoryCode: this.props.categoryCode,
        policyId: this.props.params.policyId,
      })
      .then(() => {
        this.props.navTo(
          `/account/policies/collectibles/${this.props.params.policyId}/${
            this.props.params.endorsementAction
          }/${this.props.categoryCode}/quote`
        );
      })
      .catch(this.props.onError);
  };

  render() {
    return (
      <div className="Collectibles">
        {!this.props.isEmbed &&
          compact(this.props.location.pathname.split('/')).length > 2 && (
            <TopNavBar
              isLoggedIn={this.props.isLoggedIn}
              userFullName={this.props.userFullName}
              isMenuOpen={this.props.isMenuOpen}
              activeLink={this.props.location.pathname}
              onHideMenu={this.props.hideMenu}
              onShowMenu={this.props.showMenu}
            />
          )}
        {React.cloneElement(this.props.children, {
          ...omit(this.props, 'children'),
          onSubmitAddress: this.handleSubmitAddress,
          onCompleteSurvey: this.handleCompleteSurvey,
        })}
        {this.props.toast && (
          <Toast
            message={this.props.toast.message}
            sureStyle={this.props.toast.style}
            onDismiss={this.props.hideToast}
          />
        )}
        <ModalSpinner
          message="Calculating your quote. This may take up to 15 seconds."
          isActive={this.props.isFetchingCollectiblesEndorsementQuote}
        />
      </div>
    );
  }
}

const getCategoryPropsFromParams = function(params) {
  const categoryCode = params.categoryCode;
  const categoryKey =
    findKey(COLLECTIBLES_CATEGORIES, { categoryCode }) || categoryCode;
  const categoryConfig = COLLECTIBLES_CATEGORIES[categoryKey];
  const categorySlug = `${kebabCase(categoryKey)}-insurance`;

  return {
    categorySlug,
    categoryKey,
    categoryConfig,
    categoryCode,
  };
};

const mapStateToProps = (state, ownProps) => {
  const currentScreen =
    state.collectiblesEndorsementScreens[
      state.collectiblesEndorsementCurrentScreenId
    ];
  const fields = get(currentScreen, 'fields') || [];
  const {
    categorySlug,
    categoryConfig,
    categoryCode,
  } = getCategoryPropsFromParams(ownProps.params);

  return {
    isLoggedIn: !!state.authToken,
    isMenuOpen: state.isMenuOpen,
    toast: state.toast,

    account: state.account,
    disclaimer: getDisclaimer(state.collectiblesEndorsementsPlan, 'Markel'),
    categoryCode,
    categorySlug,
    categoryConfig,
    exclusionNotice: state.collectiblesEndorsementExclusionNotice,
    fields: fields,
    flags: get(currentScreen, 'flags'),
    helpText: get(currentScreen, 'help_text'),
    isEmbed: state.isEmbed,
    isFetchingCollectiblesEndorsementQuote:
      state.isFetchingCollectiblesEndorsementQuote,
    isFirstScreen:
      get(first(state.collectiblesEndorsementScreenSequence), 'id') ===
      state.collectiblesEndorsementCurrentScreenId,
    isLastScreen:
      get(last(state.collectiblesEndorsementScreenSequence), 'id') ===
      state.collectiblesEndorsementCurrentScreenId,
    isCollectiblesEndorsementInProgress:
      state.isCollectiblesEndorsementInProgress,
    phoneNumber: get(
      state.collectiblesEndorsementResponses,
      'owner_phone_number'
    ),
    policyProvider: 'Markel',
    policiesById: state.policiesById,
    policy: state.policiesById[ownProps.params.policyId],
    purchase: state.collectiblesEndorsementPurchase,
    quote: state.collectiblesEndorsementQuote,
    propertyAddress: state.collectiblesEndorsementPropertyAddress,
    question: get(currentScreen, 'question'),
    currentResponse: state.collectiblesEndorsementCurrentResponse,
    responses: state.collectiblesEndorsementResponses,
    screenId: state.collectiblesEndorsementCurrentScreenId,
    shouldPreserveAddress: false,
    surveyType: 'Collectibles',
    submitPurchase: state.collectiblesEndorsementPurchase,
    userFullName: `${state.account.firstName} ${state.account.lastName}`,
    fullName: compact([
      state.collectiblesEndorsementResponses.owner_first_name,
      state.collectiblesEndorsementResponses.owner_middle_name,
      state.collectiblesEndorsementResponses.owner_last_name,
      state.collectiblesEndorsementResponses.owner_suffix,
    ]).join(' '),
  };
};

const mapDispatchToProps = (dispatch, ownProps) => {
  return {
    hideMenu: bindActionCreators(hideMenu, dispatch),
    hideToast: bindActionCreators(hideToast, dispatch),
    navTo: bindActionCreators(push, dispatch),
    goBack: bindActionCreators(goBack, dispatch),
    showMenu: bindActionCreators(showMenu, dispatch),

    surveyNext: bindActionCreators(collectiblesEndorsementSurveyNext, dispatch),
    getPoliciesForVertical: bindActionCreators(
      getPoliciesForVertical,
      dispatch
    ),
    getPolicyById: bindActionCreators(getPolicyById, dispatch),
    resetCollectiblesEndorsementData: bindActionCreators(
      resetCollectiblesEndorsementData,
      dispatch
    ),
    saveResponse: bindActionCreators(
      saveCollectiblesEndorsementResponse,
      dispatch
    ),
    deleteResponse: bindActionCreators(
      deleteCollectiblesEndorsementResponse,
      dispatch
    ),
    surveyBack: bindActionCreators(surveyCollectiblesEndorsementBack, dispatch),
    updateCollectiblesEndorsementAddress: bindActionCreators(
      updateCollectiblesEndorsementAddress,
      dispatch
    ),
    updateCurrentResponse: bindActionCreators(
      updateCollectiblesEndorsementCurrentResponse,
      dispatch
    ),
    getEndorsementForm: opts => {
      let returnVal;
      switch (ownProps.params.endorsementAction) {
        case 'add':
          returnVal = dispatch(getCollectiblesEndorsementAddForm(opts));
          break;
        case 'edit':
          returnVal = dispatch(getCollectiblesEndorsementEditForm(opts));
          break;
        default:
          break;
      }
      return returnVal;
    },
    getEndorsementCheckout: opts => {
      let returnVal;
      switch (ownProps.params.endorsementAction) {
        case 'add':
          returnVal = dispatch(getCollectiblesEndorsementAddCheckout(opts));
          break;
        case 'edit':
          returnVal = dispatch(getCollectiblesEndorsementEditCheckout(opts));
          break;
        default:
          break;
      }
      return returnVal;
    },
    submitPurchase: opts => {
      let returnVal;
      switch (ownProps.params.endorsementAction) {
        case 'add':
          returnVal = dispatch(purchaseCollectiblesEndorsementAdd(opts));
          break;
        case 'edit':
          returnVal = dispatch(purchaseCollectiblesEndorsementEdit(opts));
          break;
        default:
          break;
      }
      return returnVal;
    },
    backToStart: () =>
      dispatch(
        push(
          `/account/policies/collectibles/${ownProps.params.policyId}/${
            ownProps.params.endorsementAction
          }/${ownProps.params.categoryCode}`
        )
      ),
  };
};

const enhance = compose(
  withRouter,
  withGlobals({
    analyticsPrefix: 'Collectibles',
  }),
  connect(
    mapStateToProps,
    mapDispatchToProps
  )
);

export default enhance(CollectiblesEndorsementContainer);
